import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Route } from 'react-router-dom'
import PropTypes from 'prop-types'
import Logs from '@components/Logs'

import Tabs from '@components/Tabs/Tabs'
import Details from './Components/Details'
import Permissions from './Components/Permissions'
import Positions from './Components/Positions'
import Header from './Components/Header'

class Employee extends Component {
  static propTypes = {
    match: PropTypes.object,
    matchId: PropTypes.string,
    matchUrl: PropTypes.string
  }

  render () {
    const tabs = [
      {
        tab: 'details',
        roles: ['Accounting', 'Admin', 'HR']
      },
      {
        tab: 'permissions',
        roles: ['Accounting', 'Admin']
      },
      {
        tab: 'positions',
        roles: ['Accounting', 'Admin']
      },
      {
        tab: 'logs',
        roles: ['Accounting', 'Admin']
      }
    ]
    const { matchId, matchUrl, match } = this.props
    return (
      <div className='expert-wrapper'>
        <Header />
        <div className='expert-tabs'>
          <Tabs
            matchId={matchId}
            matchUrl={matchUrl}
            match={match}
            tabs={tabs}
          />
        </div>
        <div className='views-wrapper'>
          <Route exact path={match.url} component={Details} />
          <Route
            exact
            path={match.url + '/permissions'}
            component={Permissions}
            matchId={matchId}
          />
          <Route
            exact
            path={match.url + '/positions'}
            component={Positions}
            matchId={matchId}
          />
          <Route
            path={match.url + '/logs'}
            render={props => (
              <Logs {...props} type='employee' itemId={this.props.matchId} />
            )}
          />
        </div>
      </div>
    )
  }
}

export default observer(Employee)
